export default "__VITE_ASSET__De4HfgN6__"